const About = () => {
    return (
        <div style={{paddingInline: '18px',  maxHeight: '600px',
        overflowY: 'scroll'}}>
            <h4 style={{textAlign: 'center', marginTop: '19px',fontSize: '19px', color: '#1a6363'}}>About New Life Covenant Church</h4>
            <div class="block">
                <h5 style={{fontSize: '18px', marginTop: '18px'}}>Who we are and what we believe in</h5>
                <p style={{textAlign: 'justify'}}> 

                New Life Covenant Church is a Pentecostal Church with grace and commitment to sound doctrine and Bible based teaching. NLCC places Jesus Christ at the centre of the ministry and our Faith in God is uncompromising. These are our Non-Negotiables. Essentially they are at the centre of everything we do, unite us as a ministry
                </p>
            </div>
            <div class="block">
                <h5 style={{fontSize: '18px'}}>A place to belong</h5>
                <p style={{textAlign: 'justify'}}>
                Welcome to New Life Covenant Church! Whether you’ve attended church since your infancy days or are just beginning to explore the idea, we’re here to give support to you through biblical teaching, inspiring worship and fellowship which we are certain will draw you incredibly close to Christ that your life will be transformed. The transformation approach at NLCC is holistic: spirit, body, mind and heart, and our values, beliefs and culture reflect that.
                </p>

            </div>
        </div>
    );
}

export default About;